
const Whitepaper = (props) => {   
 
 
    return (            
        <div className="MainBg "style={{ width: '100%', height: '100%',}}>
            <div className="CntLdDv" >
                <div className="PrcyPlyPg" >
                    <div className="container" >
                        
                    <iframe
                                                                    title="PDF Preview"
                                                                    src="https://kkogprod.s3.amazonaws.com/KKOG_WHITEPAPER.pdf"
                                                                    style={{ width: '100%', height: '100vh', border: 'none' }}
                                                                  
                                                                ></iframe>

                    </div>
                </div>
            </div>
        </div>
    );
   
}

export default Whitepaper;